import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles, CheckCircle2 } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-12 sm:py-24 px-4 sm:px-6 lg:px-8 bg-sage text-white relative overflow-hidden" data-id="element-209">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-210"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-211">
        <FadeIn data-id="element-212">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-4 sm:mb-6 text-cream" data-id="element-213">
            <Sparkles className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-214" />
            <span className="uppercase tracking-widest font-semibold text-xs sm:text-sm" data-id="element-215">
              El Descubrimiento
            </span>
            <Sparkles className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-216" />
          </div>

          <h2 className="text-2xl sm:text-5xl font-bold text-center mb-6 sm:mb-10 leading-tight" data-id="element-217">
            La clave no es contar calorías, es gestionar el{' '}
            <span className="text-cream italic" data-id="element-218">Cortisol y la Insulina</span>.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-219">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-5 sm:p-12 border border-white/20 shadow-2xl" data-id="element-220">
            <p className="text-base sm:text-2xl leading-relaxed mb-5 sm:mb-8 font-serif" data-id="element-221">
              Hace 18 meses descubrimos algo que la industria de la pérdida de
              peso no quiere que sepas. Presentamos el{' '}
              <strong className="text-cream" data-id="element-222">
                "Método de Reinicio Hormonal 40+"
              </strong>
              .
            </p>

            <div className="space-y-4 sm:space-y-6 text-sm sm:text-lg" data-id="element-223">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-224">
                <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-cream flex-shrink-0 mt-0.5" data-id="element-225" />
                <p data-id="element-226">
                  Un sistema que <strong data-id="element-227">no te pide que dejes de comer</strong>,
                  sino que le enseñes a tu cuerpo a cambiar su combustible
                  principal de azúcar a grasa.
                </p>
              </div>
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-228">
                <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-cream flex-shrink-0 mt-0.5" data-id="element-229" />
                <p data-id="element-230">
                  Apaga el incendio inflamatorio que causa los sudores nocturnos
                  y la irritabilidad constante.
                </p>
              </div>
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-231">
                <CheckCircle2 className="w-5 h-5 sm:w-6 sm:h-6 text-cream flex-shrink-0 mt-0.5" data-id="element-232" />
                <p data-id="element-233">
                  Es el <strong data-id="element-234">"botón de reinicio"</strong> que tu biología ha
                  estado pidiendo a gritos durante años.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}